(function () {
  const CACHE_KEY = 'b2b_wishlist_cache_v2';
  const ROOT_ID = 'ssw-fave-page-side-bar';

  function skuFromHandle(handle) {
    if (!handle) return '';
    const parts = String(handle).split('-');
    return parts.length ? parts[parts.length - 1] : String(handle);
  }

  function uniqBy(arr, keyFn) {
    const seen = new Set();
    const out = [];
    for (const x of arr) {
      const k = keyFn(x);
      if (seen.has(k)) continue;
      seen.add(k);
      out.push(x);
    }
    return out;
  }

  function safeJsonParse(str) {
    try { return JSON.parse(str); } catch(e) { return null; }
  }

  function getPrevQtyMap() {
    const prev = safeJsonParse(localStorage.getItem(CACHE_KEY) || 'null');
    const map = new Map();
    if (!prev || !Array.isArray(prev.items)) return map;

    for (const it of prev.items) {
      const key = `${it.handle || ''}::${it.variantId || ''}`;
      if (!key) continue;
      const q = Number(it.qty);
      map.set(key, Number.isFinite(q) && q > 0 ? q : 1);
    }
    return map;
  }

  function getShareUrl(root) {
    const a = root.querySelector('a.ssw-share-faves._2copy[data-href]');
    return a ? a.getAttribute('data-href') : window.location.href;
  }

  function normalizeVariantCode(raw) {
    // Esempi: "Opzioni N" -> "N", "Options: G" -> "G", "N" -> "N"
    if (!raw) return '';
    const cleaned = String(raw).replace(/[:]/g, ' ').trim();
    const parts = cleaned.split(/\s+/);
    return parts.length ? parts[parts.length - 1].trim().toUpperCase() : '';
  }

  function extractFromSidebar(root, prevQtyMap) {
    const nodes = Array.from(root.querySelectorAll('.ssw-fave-item[data-handle]'));

    const items = nodes.map(el => {
      const handle = el.getAttribute('data-handle') || '';
      const variantId = el.getAttribute('data-variant-id') || '';

      const title =
        el.getAttribute('data-title') ||
        (el.querySelector('.ssw-fave-product-title') &&
         el.querySelector('.ssw-fave-product-title').textContent.trim()) ||
        '';

      const hrefEl = el.querySelector('a.ssw-fave-product-title.ssw-product-link[href*="/products/"]');
      const href = hrefEl ? new URL(hrefEl.getAttribute('href'), window.location.origin).toString() : '';

      const image = el.getAttribute('data-large') || '';

      const variantLabelEl = el.querySelector('.ssw-fave-product-options');
      const rawVariantLabel = variantLabelEl ? variantLabelEl.textContent.trim() : '';
      const variantCode = normalizeVariantCode(rawVariantLabel);

      const key = `${handle}::${variantId}`;
      const prevQty = prevQtyMap.get(key);
      const qty = prevQty ? prevQty : 1;

      return {
        title,
        handle,
        sku: skuFromHandle(handle),
        variantId,
        variantCode,
        href,
        image,
        qty
      };
    })
    // Se per qualche motivo variantId manca, evitiamo di salvare item "rotti"
    .filter(it => it.handle && it.variantId);

    return uniqBy(items, it => `${it.handle}::${it.variantId}`);
  }

  function save(root) {
    // ✅ preserva qty precedenti
    const prevQtyMap = getPrevQtyMap();

    const items = extractFromSidebar(root, prevQtyMap);
    if (!items.length) return false;

    const payload = {
      savedAt: Date.now(),
      share_url: getShareUrl(root),
      page_url: window.location.href,
      items
    };

    try { localStorage.setItem(CACHE_KEY, JSON.stringify(payload)); }
    catch (e) {}

    return true;
  }

  function attachWhenReady() {
    let tries = 0;
    const maxTries = 80;

    const timer = setInterval(() => {
      tries++;

      const root = document.getElementById(ROOT_ID);
      if (!root) {
        if (tries >= maxTries) clearInterval(timer);
        return;
      }

      save(root);

      const obs = new MutationObserver(() => save(root));
      obs.observe(root, { childList: true, subtree: true });

      clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachWhenReady);
  } else {
    attachWhenReady();
  }
})();
